// extracted by mini-css-extract-plugin
export var buttonsTrack = "component-module--buttonsTrack--fe7f1";
export var main = "component-module--main--829a6";
export var subTitle = "component-module--subTitle--198b8";
export var title = "component-module--title--504a9";
export var wrapper = "component-module--wrapper--b0ad5";